var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowrightacc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9449 13.2929C13.5521 12.6856 13.5521 11.7011 12.9449 11.0938L3.04889 1.19785C2.44163 0.590584 1.45705 0.590584 0.849789 1.19785C0.242524 1.80511 0.242524 2.78969 0.849789 3.39695L9.6462 12.1934L0.849789 20.9898C0.242524 21.597 0.242524 22.5816 0.849789 23.1889C1.45705 23.7961 2.44163 23.7961 3.04889 23.1889L12.9449 13.2929ZM11 13.7484H11.8453V10.6384H11V13.7484Z",
    fill: "#F7941E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowrightacc);
export default __webpack_public_path__ + "static/media/arrowrightacc.da3321da06209f81001ab4ddd940b572.svg";
export { ForwardRef as ReactComponent };